import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ResultsPageComponent } from './results-page/results-page.component';
import { ResultsTableComponent } from './results-page/results-table/results-table.component';
import { MaterialModule } from '../../shared-modules/material.module';
import { SharedModule } from '../../shared-modules/shared.module';

@NgModule({
    exports: [
        ResultsPageComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        ResultsPageComponent,
        ResultsTableComponent,
    ],
})
export class ResultsModule { }
